import React from 'react';
import { Button } from './ui/button';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { analytics } from '../lib/analytics';
import MoonLogo from './MoonLogo';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAuthenticated, logout } = useAuth();

  const handleLogoClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleSignup = () => {
    analytics.ctaClick('navbar_signup');
    navigate('/register');
  };

  const handleLogin = () => {
    analytics.ctaClick('navbar_login');
    navigate('/login');
  };

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-xl border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-2 cursor-pointer" onClick={handleLogoClick}>
            <MoonLogo size={32} />
            <span className="text-white font-semibold text-lg tracking-wide">moon<span className="text-[#f2e2a6]">.land</span></span>
          </div>
          
          <div className="flex items-center gap-4">
            <button 
              onClick={() => navigate('/pricing')}
              className="text-white hover:text-[#f2e2a6] transition-colors text-sm font-medium"
            >
              Pricing
            </button>

            {isAuthenticated ? (
              <>
                <button
                  onClick={() => navigate('/terminal')}
                  className="text-white hover:text-[#f2e2a6] transition-colors text-sm font-medium"
                >
                  Terminal
                </button>
                <button
                  onClick={() => navigate('/account')}
                  className="text-white hover:text-[#f2e2a6] transition-colors text-sm font-medium"
                >
                  Account
                </button>
                {user?.role === 'admin' && (
                  <button
                    onClick={() => navigate('/admin/support')}
                    className="text-white hover:text-[#f2e2a6] transition-colors text-sm font-medium"
                  >
                    Support tickets
                  </button>
                )}
                <div className="flex items-center space-x-2">
                  <span className="text-gray-400 text-sm">{user?.name || user?.email?.split('@')[0]}</span>
                  <Button 
                    onClick={handleLogout}
                    variant="outline"
                    className="border-white/20 text-white hover:bg-white/5"
                    data-testid="logout-button"
                  >
                    Logout
                  </Button>
                </div>
              </>
            ) : (
              <>
                <button 
                  onClick={handleLogin}
                  className="text-white hover:text-[#f2e2a6] transition-colors text-sm font-medium"
                  data-testid="navbar-login"
                >
                  Login
                </button>
                <Button 
                  onClick={handleSignup}
                  className="bg-[#f2e2a6] text-black hover:bg-[#f2e2a6]/90 font-semibold transition-all"
                  data-testid="navbar-signup"
                >
                  Sign Up Free
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
